/** @flow */

import {
  GetRtw,
  GetRtwSuccess,
  GetRtwError,
  GetRtwSchema,
  GetRtwSchemaSuccess,
  GetRtwSchemaError,
  NewRtw,
  StartDraftRtwSuccess,
  SetRtwDraft,
  NewRtwAssignments,
  SetRtwAssignments,
  SetRtwEnabled,
  SetShowAddRtwAttachmentModal,
  UpdateRtwSuccess,
  SetRtwDraftAssignments,
  ChangeAddFileInProgress,
  GetRtwProcesses,
  GetRtwProcessesSuccess,
  GetRtwProcessesError,
  SetRTWLiveProcessesFilter,
  UpdateRtw,
  UpdateRtwError,
  DisableRtw,
  DisableRtwSuccess,
  DisableRtwError,
  AddRtw,
  AddRtwSuccess,
  AddRtwError,
  ResetRtwState,
} from "@modules/service/constants/actions";
import * as serviceReducers from "./reducers";
import initialState from "./state";
import type { RtwStateType } from "./types";
import { cloneObject } from "@utils/object";

export default (state: RtwStateType = initialState, action: Object): RtwStateType => {
  const act = {
    [SetRTWLiveProcessesFilter]: serviceReducers.onSetRTWLiveProcessesFilter,
    [GetRtwProcesses]: serviceReducers.onGetRtwProcesses,
    [GetRtwProcessesSuccess]: serviceReducers.onGetRtwProcessesSuccess,
    [GetRtwProcessesError]: serviceReducers.onGetRtwProcessesError,

    [DisableRtw]: serviceReducers.onDisableRtw,
    [DisableRtwSuccess]: serviceReducers.onDisableRtwSuccess,
    [DisableRtwError]: serviceReducers.onDisableRtwError,

    [AddRtw]: serviceReducers.onAddRtw,
    [AddRtwSuccess]: serviceReducers.onAddRtwSuccess,
    [AddRtwError]: serviceReducers.onAddRtwError,

    [GetRtw]: serviceReducers.onGet,
    [GetRtwSuccess]: serviceReducers.onGetSuccess,
    [GetRtwError]: serviceReducers.onGetError,
    [GetRtwSchema]: serviceReducers.onGetSchema,
    [GetRtwSchemaSuccess]: serviceReducers.onGetSchemaSuccess,
    [GetRtwSchemaError]: serviceReducers.onGetSchemaError,
    [NewRtw]: serviceReducers.onNew,
    [StartDraftRtwSuccess]: serviceReducers.onStartDraftSuccess,
    [SetRtwDraft]: serviceReducers.onSetRtwDraft,
    [NewRtwAssignments]: serviceReducers.onNewAssignments,
    [SetRtwAssignments]: serviceReducers.onSetAssignments,
    [SetRtwDraftAssignments]: serviceReducers.onSetRtwDraftAssignments,
    [SetRtwEnabled]: serviceReducers.onSetEnabled,
    [SetShowAddRtwAttachmentModal]: serviceReducers.onSetShowAddRtwAttachmentModal,
    [ChangeAddFileInProgress]: serviceReducers.onChangeAddFileInProgress,
    [UpdateRtw]: serviceReducers.onUpdateRtw,
    [UpdateRtwError]: serviceReducers.onUpdateRtwError,
    [UpdateRtwSuccess]: serviceReducers.onUpdateRtwSuccess,
    [ResetRtwState]: serviceReducers.onResetRtwState,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
